import { caesarTriggerApi } from "./config";

const caesarTriggerApiWithTag = caesarTriggerApi.enhanceEndpoints({
  addTagTypes: ["users-list"],
});

const caesarApiSlice = caesarTriggerApiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    triggerCaesarCopy: builder.query({
      query: () => ({
        url: `/idrs`,
      }),
    }),
  }),
});

export const { useLazyTriggerCaesarCopyQuery } = caesarApiSlice;

export default caesarApiSlice;
